import { createPageApp } from '@/lib/createPageApp'
import EventDescriptionPage from './EventDescriptionPage.vue'

createPageApp(EventDescriptionPage).mount()
